import { useState, useEffect } from 'react';

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  useEffect(() => {
    function handleResize() {

      // This conditional handles the edge cases when a user resizes the window.
      // It addresses the mobile phone interactive section which shifts from mobile to desktop at 1024.
      // It reloads the page so its specific layouts display properly. 
      if (
        (window.innerWidth > 1023 && windowSize.width < 1024) ||
        (window.innerWidth < 1024 && windowSize.width > 1023)) {
        window.location.reload();
      }

      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener('resize', handleResize);
    // handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}
